import classNames from "classnames";

interface LabelTagProps {
  text: string;
  color?: string;
  backgroundColor?: string;
}

export function LabelTag(props: LabelTagProps) {
  return (
    <div
      className={classNames(
        "tw:inline-flex tw:items-center tw:max-w-full tw:font-sofia-pro tw:font-semibold tw:text-sm tw:uppercase",
        "tw:tracking-normal tw:text-left tw:transition-colors",
        "tw:rounded-2xl tw:py-2 tw:px-2.5 tw:mr-2 tw:mb-2 tw:gap-1",
      )}
      style={{ color: props.color, backgroundColor: props.backgroundColor }}
    >
      {props.text}
    </div>
  );
}
